export default "__VITE_ASSET__BM28i3WV__"